import { useBrand } from 'reaxl-brand';
import { useFeature } from '@atc/features';
import { useSelector } from 'react-redux';
import analytics from '.';
import useDataLayer from './useDataLayer';
import { kbbBrand } from '../constants/index';

function useAnalyticsProps({ disablePostMessage = false } = {}) {
    const { isBrand } = useBrand();
    const isKbb = isBrand(kbbBrand);
    const [, { disableGtm, disableGtmEvents }] = useFeature('google_analytics');

    const analyticsProps = {
        value: {
            ...analytics,
        },
        dataLayer: useDataLayer(),
        getDataIsland: useSelector((state) => state?.birf?.pageData),
        option: {
            disableGTM: disableGtm,
            disableGTMEvents: disableGtmEvents,
            disablePostMessage,
            ...(isKbb && {
                isOptimizelyEdge: true,
                populateChannelManager: false,
            }),
        },
    };

    return analyticsProps;
}

export default useAnalyticsProps;
